import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import '../assets/styles/GetAquote.css';

function GetAquote() {
  const [formData, setFormData] = useState({
    fullNames: '',
    email: '',
    phone: '',
    subject: '',
    deliveryCity: '',
    departureCity: '',
    weight: '',
    height: '',
    fragile: false,
    expressDelivery: false,
    insurance: 'no',
    packaging: 'standard',
  });
  const [status, setStatus] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simulate form submission
    setStatus('success');
    setFormData({
      fullNames: '',
      email: '',
      phone: '',
      subject: '',
      deliveryCity: '',
      departureCity: '',
      weight: '',
      height: '',
      fragile: false,
      expressDelivery: false,
      insurance: 'no',
      packaging: 'standard',
    });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  return (
    <>
      <Helmet>
        <title>RFF Cargo: Request a Quote</title>
        <meta name="description" content="Request a personalized quote for your shipping needs with RFF Cargo." />
      </Helmet>
      <section className="quote-section py-5">
        <div className="container">
          <div className="row">
            {/* Left Column */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <h2 className="quote-title fw-bold mb-4">Get A Quote</h2>
              <ul className="quote-list">
                <li className="quote-list-item">
                  <i className="bi bi-check-circle-fill me-2" aria-label="Checkmark"></i>
                  <span className="quote-text">Request a personalized shipping quote tailored to your needs.</span>
                </li>
                <li className="quote-list-item">
                  <i className="bi bi-check-circle-fill me-2" aria-label="Checkmark"></i>
                  <span className="quote-text">Get fast and accurate quote responses within 24 hours.</span>
                </li>
                <li className="quote-list-item">
                  <i className="bi bi-check-circle-fill me-2" aria-label="Checkmark"></i>
                  <span className="quote-text">Track your cargo in real-time with our advanced system.</span>
                </li>
                <li className="quote-list-item">
                  <i className="bi bi-check-circle-fill me-2" aria-label="Checkmark"></i>
                  <span className="quote-text">Our global logistics expertise ensures safe and efficient delivery worldwide.</span>
                </li>
              </ul>
              <h3 className="help-title fw-bold mt-5 mb-3">How we can help you?</h3>
              <Link to="/contact" className="btn btn-contact-us" aria-label="Contact Us">
                Contact Us
              </Link>
            </div>
            {/* Right Column */}
            <div className="col-lg-6">
              <h2 className="form-title fw-bold mb-4">Request a Quote</h2>
              {status === 'success' && (
                <div className="alert alert-success alert-dismissible fade show" role="alert">
                  Your quote request has been submitted successfully!
                  <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
              )}
              <form onSubmit={handleSubmit} className="quote-form">
                {/* Row 1: Full Names, Email */}
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label htmlFor="fullNames" className="form-label">Full Names</label>
                    <input
                      type="text"
                      className="form-control"
                      id="fullNames"
                      name="fullNames"
                      value={formData.fullNames}
                      onChange={handleChange}
                      required
                      aria-required="true"
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="email" className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      aria-required="true"
                    />
                  </div>
                </div>
                {/* Row 2: Phone, Subject */}
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label htmlFor="phone" className="form-label">Phone</label>
                    <input
                      type="tel"
                      className="form-control"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      aria-required="true"
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="subject" className="form-label">Subject</label>
                    <input
                      type="text"
                      className="form-control"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      aria-required="true"
                    />
                  </div>
                </div>
                {/* Row 3: Delivery City, City of Departure */}
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label htmlFor="deliveryCity" className="form-label">Delivery City</label>
                    <input
                      type="text"
                      className="form-control"
                      id="deliveryCity"
                      name="deliveryCity"
                      value={formData.deliveryCity}
                      onChange={handleChange}
                      required
                      aria-required="true"
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="departureCity" className="form-label">City of Departure</label>
                    <input
                      type="text"
                      className="form-control"
                      id="departureCity"
                      name="departureCity"
                      value={formData.departureCity}
                      onChange={handleChange}
                      required
                      aria-required="true"
                    />
                  </div>
                </div>
                {/* Row 4: Weight, Height */}
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label htmlFor="weight" className="form-label">Weight (kg)</label>
                    <input
                      type="number"
                      className="form-control"
                      id="weight"
                      name="weight"
                      value={formData.weight}
                      onChange={handleChange}
                      required
                      aria-required="true"
                      min="0"
                      step="0.1"
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="height" className="form-label">Height (cm)</label>
                    <input
                      type="number"
                      className="form-control"
                      id="height"
                      name="height"
                      value={formData.height}
                      onChange={handleChange}
                      required
                      aria-required="true"
                      min="0"
                      step="0.1"
                    />
                  </div>
                </div>
                {/* Row 5: Fragile, Insurance | Express Delivery, Packaging */}
                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Fragile</label>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="fragile"
                          name="fragile"
                          checked={formData.fragile}
                          onChange={handleChange}
                        />
                        <label htmlFor="fragile" className="form-check-label">Fragile</label>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Insurance</label>
                      <div className="form-check">
                        <input
                          type="radio"
                          className="form-check-input"
                          id="insuranceYes"
                          name="insurance"
                          value="yes"
                          checked={formData.insurance === 'yes'}
                          onChange={handleChange}
                        />
                        <label htmlFor="insuranceYes" className="form-check-label">Yes</label>
                      </div>
                      <div className="form-check">
                        <input
                          type="radio"
                          className="form-check-input"
                          id="insuranceNo"
                          name="insurance"
                          value="no"
                          checked={formData.insurance === 'no'}
                          onChange={handleChange}
                        />
                        <label htmlFor="insuranceNo" className="form-check-label">No</label>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Express Delivery</label>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="expressDelivery"
                          name="expressDelivery"
                          checked={formData.expressDelivery}
                          onChange={handleChange}
                        />
                        <label htmlFor="expressDelivery" className="form-check-label">Express Delivery</label>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Packaging</label>
                      <div className="form-check">
                        <input
                          type="radio"
                          className="form-check-input"
                          id="packagingStandard"
                          name="packaging"
                          value="standard"
                          checked={formData.packaging === 'standard'}
                          onChange={handleChange}
                        />
                        <label htmlFor="packagingStandard" className="form-check-label">Standard</label>
                      </div>
                      <div className="form-check">
                        <input
                          type="radio"
                          className="form-check-input"
                          id="packagingPremium"
                          name="packaging"
                          value="premium"
                          checked={formData.packaging === 'premium'}
                          onChange={handleChange}
                        />
                        <label htmlFor="packagingPremium" className="form-check-label">Premium</label>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Row 6: Submit Button */}
                <button type="submit" className="btn btn-request-quote">Request A Quote</button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default GetAquote;